import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

export const CommonServiceCrumbs: Array<BreadcrumbItem> = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Servizi',
    path: '/sistema/servizi',
  },
];
